import { Button } from '@/components/ui/button';
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Label } from '@/components/ui/label';
import { Textarea } from '@/components/ui/textarea';

export function LeadArchiveDialog({ open, onOpenChange, archiveReason, setArchiveReason, archiveLead }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md">
        <DialogHeader><DialogTitle>Archive Lead</DialogTitle><DialogDescription>Move this lead out of the active workspace while keeping its history.</DialogDescription></DialogHeader>
        <div><Label>Archive Reason *</Label><Textarea value={archiveReason} onChange={(event) => setArchiveReason(event.target.value)} placeholder="No response, duplicate, out of service area..." data-testid="lead-archive-reason" /></div>
        <DialogFooter>
          <Button type="button" variant="outline" onClick={() => onOpenChange(false)} data-testid="lead-archive-cancel">Cancel</Button>
          <Button type="button" onClick={archiveLead} disabled={!archiveReason.trim()} data-testid="lead-archive-confirm">Archive</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}